import Divider from '@material-ui/core/Divider'
// MUI
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'

type HeaderProps = {
  name: string
}
export const Header: React.FC<HeaderProps> = ({ name }) => {
  return (
    <Grid container alignItems='center' spacing={2}>
      <DividerWrapper>
        <Typography variant='overline'>{name}</Typography>
      </DividerWrapper>
    </Grid>
  )
}
export const DividerWrapper: React.FC<React.PropsWithChildren> = ({ children }) => {
  return (
    <>
      <Grid item xs>
        <Divider />
      </Grid>
      <Grid item>{children}</Grid>
      <Grid item xs>
        <Divider />
      </Grid>
    </>
  )
}
